export default __webpack_public_path__ + "static/media/verificationIcon.cdb6e448.svg";